import { KYMW2400Model } from '../kymw2400.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * データキャンセル
 *
 * @export CancelDataService
 * @class CancelDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class CancelDataService {

  private model: KYMW2400Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
  }

  /**
   * データキャンセル処理
   *
   * @param {KYMW2400Model} model モデルクラス
   * @memberof CancelDataService
   */
  execute(model: KYMW2400Model) {
    this.model = model;
    this.model.cancelData();
  }
}
